import { TimesheetInterface } from '../../../interfaces/timesheet.interface';

export class LoadTimeSheetsSuccess {
    public static readonly type = '[JobsPlacements] Load timesheets success';

    constructor(public timesheets: Array<TimesheetInterface>) { }
}
